import React from 'react';
import './WhyUsPage.css';

const HeroBlock = ({ label, title, text, image, chipOne = 'Live Tracking', chipTwo = '24/7 Control Room' }) => (
  <section className="enhanced-hero" style={{ backgroundImage: `url(${image})` }}>
    <div className="container enhanced-hero-grid">
      <div className="enhanced-copy reveal-left">
        <span className="section-label eyebrow-dark">{label}</span>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{text}</p>

        <div className="hero-actions">
          <a href="/contact-us" className="btn btn-primary">Get Free Consultation</a>
          <a href="/packages" className="btn btn-outline">View Packages</a>
        </div>

        <div className="hero-metrics">
          <span><strong>6,500+</strong>Vehicles Served</span>
          <span><strong>24/7</strong>Monitoring</span>
          <span><strong>2019</strong>Since</span>
        </div>
      </div>

      <div className="hero-visual-wrap reveal">
        <div className="floating-orbit" />
        <div className="float-chip one"><b />{chipOne}</div>
        <div className="float-chip two"><b />{chipTwo}</div>

        <div className="hero-visual">
          <img src={image} alt={label} />
        </div>
      </div>
    </div>
  </section>
);

const reasons = [
  [
    'SW',
    'In-House Software',
    'DTS owns and customizes its platform, so dashboards, alerts, reports, and integrations can match your needs.'
  ],
  [
    '24',
    '24/7 Support',
    'Vehicle emergencies do not follow office hours, so our team stays available via phone, WhatsApp, and email.'
  ],
  [
    'CR',
    'Control Room Monitoring',
    'Trained monitoring representatives respond to theft, unauthorized movement, and safety violations.'
  ],
  [
    'DS',
    'Data Security',
    'Customer data privacy and secure platform access are treated as core service priorities.'
  ],
  [
    'CX',
    'Custom Solutions',
    'From one car to hundreds of vehicles, DTS recommends the right package and module set.'
  ],
  [
    'PK',
    'Nationwide Coverage',
    'Karachi-based support with services designed for major cities and business routes across Pakistan.'
  ]
];

const WhyUsPage = () => (
  <main className="enhanced-page why-enhanced">
    <HeroBlock
      label="Why Choose DTS"
      title="Your Long-Term <em>Tracking Partner</em>"
      text="Choosing a GPS tracking company is not just buying a device. It is selecting a technology partner for security, visibility, response, and operational growth."
      image="/dts-assets/ai/why-us-hero.png"
      chipOne="Reliable Support"
      chipTwo="Proven Track Record"
    />

    <section className="enhanced-section alt">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">DTS Advantage</span>
          <h2>Reasons Customers Trust <em>Dynamic Tracking</em></h2>
          <div className="divider" />
          <p>
            Every service is arranged around speed, reliability, security, and customer
            satisfaction.
          </p>
        </div>

        <div className="card-grid">
          {reasons.map((reason, index) => (
            <div
              className="info-card reveal"
              style={{ transitionDelay: `${index * 60}ms` }}
              key={reason[1]}
            >
              <div className="info-icon">{reason[0]}</div>
              <h3>{reason[1]}</h3>
              <p>{reason[2]}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="enhanced-section dark-band">
      <div className="container split-grid">
        <div className="feature-panel feature-panel-readable reveal-left">
          <span className="section-label">Performance</span>
          <h2>Built for Real-World Fleet Pressure</h2>
          <p>
            Fuel issues, route deviations, theft threats, idle time, maintenance delays,
            and driver behavior problems require more than basic location tracking. DTS gives
            you layered control through hardware, software, alerts, and human monitoring.
          </p>
        </div>

        <div className="media-card reveal">
          <img src="/dts-assets/ai/why-us-hero.png" alt="Fleet performance" />
        </div>
      </div>
    </section>
  </main>
);

export default WhyUsPage;